import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { DataGridDescriptionCell } from "~/components/DataGrid/DataGridDescriptionCell";

// // // //

export const DESCRIPTION_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.description,
    sortsOn: AssetColumns.description,
    label: "Description",
    type: ColumnTypes.string,
    width: 320,
    render: (item) => {
        if (!item.isAsset) return null;

        return (
            <DataGridDescriptionCell text={item.description} maxLength={50} />
        );
    },
};
